import { connect } from 'react-redux';
import { dispatchify } from 'common/utils/utils';
import {
  getPullRequests,
  getCommitStats,
  toggleModal,
  toggleSnackBar
} from 'state/callers';

import {
  datesFromSelectedTillNowSelector,
  currentIterationSelector
} from 'state/selectors/iterations-picker';
import { prMergedGroupedByDaySelector } from 'state/selectors/prs';
import { codeChangesGroupedByDaySelector } from 'state/selectors/commit-stats';
import CustomReportNew from './CustomReport.new';
import {
  licenseSelector,
  isTeamLicenseSelector
} from 'state/selectors/license';
import { myAccountSelector } from 'state/selectors/account';
import { selectTeamId } from 'state/actions';

const mapStateToProps = state => {
  const { uiState, categories } = state;
  return {
    uiState,
    categories,
    datesFromSelectedTillNow: datesFromSelectedTillNowSelector(state),
    prMergedGroupedByDay: prMergedGroupedByDaySelector(state),
    codeChangesGroupedByDay: codeChangesGroupedByDaySelector(state),
    currentIteration: currentIterationSelector(state),
    license: licenseSelector(state),
    isTeamLicense: isTeamLicenseSelector(state),
    myAccount: myAccountSelector(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...dispatchify(dispatch, {
      getPullRequests,
      getCommitStats,
      toggleModal,
      toggleSnackBar,
      selectTeamId
    })
  };
};

export const NewCustomReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomReportNew);
